<template>
  <div style="padding-bottom: 50px;background-color: #fff;">
    <HomeHeaderView />
    <HomeBannerView />
    <HomeMenuView />
    <TmpAccount />
    <HomeBorrowingView />
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/footer/index.vue"
import { HomeHeaderView, HomeBannerView, HomeMenuView, TmpAccount,HomeBorrowingView } from './components/index'
export default {
  name: 'HomeView',
  components: { Footer,HomeHeaderView,HomeBannerView,HomeMenuView,TmpAccount,HomeBorrowingView }
}
</script>
